import React, { useCallback, useEffect, useState } from 'react';

import { useBranchContext } from 'state/branch';
import { useBrazeContext } from 'state/braze';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useMParticleContext } from 'state/mParticle';
import LogRocketHelper from 'utils/logrocket';

import useOneTrustSdk from './use-one-trust-sdk';

export const OneTrustCookieBanner = () => {
  const enableLogRocket = useFlag(LaunchDarklyFlag.ENABLE_LOGROCKET);
  const { init: initMParticle } = useMParticleContext();
  const { initBraze } = useBrazeContext();
  const { initBranch } = useBranchContext();
  const lrInstance = LogRocketHelper.getInstance().logrocket;

  const { loaded: otSdkLoaded } = useOneTrustSdk();

  const [bannerClosed, setBannerClosed] = useState(false);
  const [servicesLoaded, setServiceLoaded] = useState(false);

  // Function to set one trust cookie banner closed flag
  const cookieBannerClosed = useCallback(() => {
    const isCookieBannerClosed = document.cookie
      .split(';')
      .some(item => item.trim().startsWith('OptanonAlertBoxClosed='));

    setBannerClosed(isCookieBannerClosed);
  }, []);

  // Sets a interval to check if banner is closed or not
  useEffect(() => {
    const id = setInterval(cookieBannerClosed, 3000);

    if (bannerClosed) {
      clearInterval(id);
    }

    return () => clearInterval(id);
  }, [bannerClosed, cookieBannerClosed]);

  // Fucntion to initialize 3rd party services
  const initServicesWithCookies = useCallback(() => {
    if (!window.mParticle) {
      initMParticle();
    }
    if (enableLogRocket && !lrInstance) {
      LogRocketHelper.init();
    }
    if (!window.rbiAppboy) {
      initBraze();
    }
    if (!window.branch) {
      initBranch();
    }
    setServiceLoaded(true);
  }, [enableLogRocket, initBranch, initBraze, initMParticle, lrInstance]);

  // Loads 3rd party services once one trust sdk is loaded and banner is closed
  useEffect(() => {
    if (otSdkLoaded && bannerClosed && !servicesLoaded) {
      initServicesWithCookies();
    }
  }, [otSdkLoaded, initServicesWithCookies, servicesLoaded, setServiceLoaded, bannerClosed]);

  return <div data-testid="one-trust-cookie-banner" />;
};
